<template>
  <el-dialog :title="dialogName" :class="[currentTheme]" :visible.sync="dialogVisible" class="no-header-dialog" :close-on-click-modal="false" width="600px" append-to-body>
    <div class="main-box">
      <el-form ref="dataForm" class="main-form" :model="temp" :rules="rules" label-width="100px" size="small">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="机构名称">
              <el-input v-model="temp.orgName" disabled style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="字典类型">
              <el-input v-model="temp.dictType" disabled style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="字典标签" prop="dictLabel">
              <el-input v-model="temp.dictLabel" placeholder="请输入字典标签" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="显示排序">
              <el-input-number v-model="temp.dictSort" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="状态">
              <el-radio-group v-model="temp.status" size="mini">
                <el-radio label="0">正常</el-radio>
                <el-radio label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="temp.remark" placeholder="请输入内容" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="form-footer">
        <xr-button type="primary" @click="save('dataForm')">确定</xr-button>
        <xr-button type="default" @click="dialogVisible = false">取消</xr-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "medicalDictInfo",
  data() {
    return {
      dialogName: '添加字典数据',
      dialogVisible: false,
      currentTheme: '',
      type: 'add',
      isSaving:false,
      temp: {
        dictCode: '',
        dictType: '',
        dictValue: '',
        dictLabel: '',
        dictSort: 0,
        orgId: '',
        orgName: '',
        status: '0',
        remark: ''
      },
      orgList: [],
      rules: {
        dictLabel: [
          { required: true, message: '请输入字典标签', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    init(dictType,type, dictCode) {
      this.type = type;
      this.temp.dictCode = dictCode
       this.temp.dictType = dictType
      this.dialogName = type === 'add' ? '添加字典数据' : '编辑字典数据';
      this.dialogVisible = true;

      this.getPageInfo()
    },
    resetTemp() {
      this.temp = {
        dictCode: '',
        dictType: '',
        dictValue: '',
        dictLabel: '',
        dictSort: 0,
        orgId: '',
        orgName: '',
        status: '0',
        remark: ''
      };
    },
    getPageInfo() {
      return this.request({
      	  method:'post',
      	  url:'/web/service',
      	  params:{
      	    'method': 'tCoreMedicalDict_getPageInfo',
            'type': this.type,
      	    'dictCode': this.temp.dictCode
      	  }
      	}).then((response) => {
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(response.data && response.data.info){
            this.temp = response.data.info
          }
          if(response.data && response.data.org_info){
            this.temp.orgId = response.data.org_infoid
            this.temp.orgName = response.data.org_info.orgName
          }
        })
    },
    //保存
    save(formName) {
      if (this.isSaving) {
        return; // 如果正在保存中，则直接返回，避免重复保存
      }
      let url = '/web/service?method=tPhMedicalDict_edit'
      if (this.type === 'add') {
        url = '/web/service?method=tPhMedicalDict_save'
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isSaving = true
          return this.request({
            method: 'post',
            url: url,
            params: this.temp
          }).then((response) =>{
            if (response.code === 0) {
              this.isSaving = false
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false
                  this.$emit('refreshData')
                }
              })
            } else {
              this.isSaving = false
              this.$message.error(response.msg)
            }
          })
        } else {
          this.isSaving = false
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
};
</script>

<style scoped>
.main-box {
  padding: 20px;
}

.form-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.form-footer .el-button {
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/dict/medical_dict_info.vue